import React from 'react';
import LuxuryBoxForm from 'forms/LuxuryBoxForm';

export default (): JSX.Element => <LuxuryBoxForm />;
